import { FAQStatic } from '../components/FAQStatic';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildFaqPageSchema } from '../lib/schema';
import { FAQ_META } from '../lib/seo';

export function FaqPage() {
  return (
    <MarketingLandingShell>
      <PageSeo meta={FAQ_META} />
      <JsonLd data={buildFaqPageSchema()} />
      <FAQStatic />
    </MarketingLandingShell>
  );
}
